import { Button, Container, Flex, HStack, Stack } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import { AxiosInstance } from 'axios';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';

import { LoadingSpinner } from '../../components/LoadingSpinner';
import { simpleInput } from '../../helpers/makeFormFields';
import useInviteChainManagerMutation from '../../hooks/mutations/useInviteChainManagerMutation';
import useChainQuery from '../../hooks/useChainQuery';
import { IChainForm } from './ChainForm';

export interface IInviteChainManagerForm {
  token: string | undefined;
  axios: AxiosInstance;
  chainId: number;
  firstname: string;
  lastname: string;
  email: string;
}

const ChainManagerForm = (props: { id: number }) => {
  const { id } = props;
  const chainQuery = useChainQuery(id);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { mutate: inviteChainManager } = useInviteChainManagerMutation(id);
  const schema = yup
    .object({
      firstname: yup.string().required(t('forms:firstname.error')),
      lastname: yup.string().required(t('forms:lastname.error')),
      email: yup
        .string()
        .email()
        .matches(/^[^äÄöÖüÜ]*$/, { message: t('forms:email.special_characters') })
        .label(t('forms:email.label'))
        .required(),
    })
    .required();

  const {
    handleSubmit,
    formState: { errors },
    setError,
    register,
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onSubmit',
    reValidateMode: 'onChange',
  });

  const onSubmit: SubmitHandler<yup.InferType<typeof schema>> = ({ firstname, lastname, email }) => {
    inviteChainManager(
      {
        firstname,
        lastname,
        email,
      },
      {
        onError: (error: any) => {
          const { errors } = error.response.data;

          (Object.keys(errors) as Array<keyof IChainForm>).forEach((key) => {
            setError(key as any, {
              type: 'server',
              message: errors[key]!.join('. '),
            });
          });
        },
      },
    );
  };

  if (chainQuery.isLoading) {
    return <LoadingSpinner />;
  }
  return (
    <Stack w="full">
      <Container as="form" onSubmit={handleSubmit(onSubmit)}>
        <Stack px={{ base: '4', md: '6' }} py={{ base: '5', md: '6' }}>
          <Stack direction={['column']}>
            {simpleInput({
              name: 'firstname',
              label: t('forms:firstname.label'),
              register,
              errors,
            })}
            {simpleInput({
              name: 'lastname',
              label: t('forms:lastname.label'),
              register,
              errors,
            })}
            {simpleInput({
              name: 'email',
              label: t('forms:email.label'),
              register,
              errors,
            })}
          </Stack>

          <Flex direction="row-reverse" py="4" px={{ base: '4', md: '6' }}>
            <HStack>
              <Button
                color={'red.600'}
                borderColor={'red.600'}
                //@ts-ignore
                _hover={'pink.600'}
                variant="outline"
                onClick={() => {
                  navigate(`/app/op/chains/${id}`);
                }}
              >
                {t('common:abort')}
              </Button>

              <Button type="submit" variant="primary">
                {t('common:invite')}
              </Button>
            </HStack>
          </Flex>
        </Stack>
      </Container>
    </Stack>
  );
};
export default ChainManagerForm;
